/**
 * Era-accurate sprites: the PokeAPI sprites repo keeps per-generation pixel
 * art under `versions/<gen>/<folder>/`. This maps a selected game (version
 * group) to the closest sprite folder. Games newer than Gen 7 shipped no
 * pixel sprites — those return null and the caller falls back to HOME art.
 */
const REPO = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions';

const PATH_BY_VERSION_GROUP = {
  'red-blue': 'generation-i/red-blue',
  'red-green-japan': 'generation-i/red-blue',
  'blue-japan': 'generation-i/red-blue',
  yellow: 'generation-i/yellow',
  'gold-silver': 'generation-ii/gold',
  crystal: 'generation-ii/crystal',
  'ruby-sapphire': 'generation-iii/ruby-sapphire',
  emerald: 'generation-iii/emerald',
  'firered-leafgreen': 'generation-iii/firered-leafgreen',
  'diamond-pearl': 'generation-iv/diamond-pearl',
  platinum: 'generation-iv/platinum',
  'heartgold-soulsilver': 'generation-iv/heartgold-soulsilver',
  'black-white': 'generation-v/black-white',
  'black-2-white-2': 'generation-v/black-white',
  'x-y': 'generation-vi/x-y',
  'omega-ruby-alpha-sapphire': 'generation-vi/omegaruby-alphasapphire',
  'sun-moon': 'generation-vii/ultra-sun-ultra-moon',
  'ultra-sun-ultra-moon': 'generation-vii/ultra-sun-ultra-moon',
  'brilliant-diamond-and-shining-pearl': 'generation-viii/brilliant-diamond-shining-pearl',
};

/** URL for a game-era pixel sprite, or null if that game has none. */
export function gameSpriteUrl(id, versionGroupKey, { shiny = false } = {}) {
  const path = PATH_BY_VERSION_GROUP[versionGroupKey];
  if (!path) return null;
  return `${REPO}/${path}/${shiny ? 'shiny/' : ''}${id}.png`;
}

export function hasGameSprites(versionGroupKey) {
  return Boolean(PATH_BY_VERSION_GROUP[versionGroupKey]);
}
